import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import MissionSelectMultiple from 'component/menuMission/MissionSelectMultiple'

class ApproversEditForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      missionsSelected: [],
      missionsChoosed: false,
      dsLdap: '',
      ldapDisabled: false,
      missionDisabled: false,
    }
  }

  beforeSubmit = () => {
    if (this.state.missionsSelected) {
      this.handleSubmit()
    }
  }

  handleSubmit = () => {
    const {
      onSubmit,
      values: { dsMissions },
    } = this.props
    const mapMissions = dsMissions.map((a) => a.label)
    onSubmit(mapMissions)
    this.clearFields()
  }

  handleChangeMissions = (value) => {
    const { fields } = this.props
    fields.dsMissions.input.onChange(value)
  }

  clearFields = () => {
    const { setValueToField } = this.props
    setValueToField('dsMissions', [])
  }

  render() {
    const {
      translate,
      fields,
      values,
      auth: { user },
      options,
    } = this.props

    const { missionsSelected } = this.state

    return (
      <form className='ApproversEditForm'>
        <fieldset>
          <Row>
            <Col xs={12}>
              <legend>
                {translate('usage-consumption-approvers.mission-data')}
              </legend>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={12}>
              <Field
                {...fields.dsMissions}
                error={translate(fields.dsMissions.error)}
                label={translate('usage-consumption-approvers.choose-mission')}
                input={{ value: missionsSelected }}
              >
                <MissionSelectMultiple
                  {...fields.dsMissions.input}
                  values={values.dsMissions}
                  placeholder={translate(
                    'usage-consumption-approvers.choose-mission'
                  )}
                  onChange={(value) => {
                    this.handleChangeMissions({ target: { value } })
                  }}
                  user={user}
                  translate={translate}
                  options={options}
                />
              </Field>
            </Col>
          </Row>
        </fieldset>

        <Row className='margin-top-double margin-bottom'>
          <Col xs={6} md={6}>
            <button
              role='button'
              type='button'
              onClick={() => this.props.resetForm()}
              className='button-hollow button-hollow-danger button-full align-center'
            >
              {translate('cancel_button_label')}
            </button>
          </Col>

          <Col xs={6} md={6}>
            <button
              disabled={
                !fields.dsMissions.input.value ||
                fields.dsMissions.input.value.length === 0
              }
              role='button'
              type='button'
              onClick={() => this.handleSubmit()}
              className='button button-primary button-full'
            >
              {translate('save_button_label')}
            </button>
          </Col>
        </Row>
      </form>
    )
  }
}

ApproversEditForm.propTypes = {
  fields: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  invertStates: PropTypes.func.isRequired,
  setValueToField: PropTypes.func,
  resetForm: PropTypes.func,
  options: PropTypes.array,
}

const fields = ['dsMissions']

export default Form({ fields })(ApproversEditForm)

export { ApproversEditForm }
